export const isUser = localStorage.getItem('type') === 'user';